module.exports = __webpack_public_path__ + "img/company_image.691bd09a.png";